import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { NEWEST_BACKEND } from "@/remotes";
import { ref, computed, onMounted } from "vue";
import { refreshPackagesAPI, refreshTimePickup } from "@/utils/refreshPackages";
import { requiredNeeded } from "@/utils/baseFunctions";
import { getPackageKey } from "@/utils/tabsFunctions";

export default {
  props: {
    cities: Array,
    natures: Array,
  },


  setup() {
    const dataForm = useDataFormStore();

    const natureDropdown = ref();

    // Характер груза
    const natures = ref([]);
    const fnatures = ref([]);
    
    onMounted(async function () {

      // Запрос типы посылок
      try {
        const { data } = await NEWEST_BACKEND.get(`/public/cargo-natures`);
        natures.value = data;

        fnatures.value = natures.value;
      } catch (e) {
        console.log(e);
      }
    });

    const optionsWhoPaysTheRansom = [
      {
        value: "0",
        label: "За счёт средств клиента",
      },
      {
        value: "1",
        label: "За счет ТК ЛУЧ",
      },
    ];

    const communications = [
      {
        value: "Email",
        label: "Email",
      },
      {
        value: "Viber",
        label: "Viber",
      },
      {
        value: "WhatsApp",
        label: "WhatsApp",
      },
    ];

    function checkIntersectionsTypes(types, typeName) {
      return !(
        dataForm.packages.additionalPackagingGroup.filter((type) =>
          types.includes(type)
        ).length === dataForm.packages.additionalPackagingGroup.length &&
        !(typeName == 'Стретч' && dataForm.services.packageSpecs == '1')
      );
    }   

    function refreshPackages(index) {
      refreshPackagesAPI(index);
      refreshTimePickup();
    }

    const requiredPackages = computed(() =>
      (dataForm.services.typeOfPackagings.value || []).filter(t => t.isRequired)
    );

    const optionalPackages = computed(() =>
      (dataForm.services.typeOfPackagings.value || []).filter(t => !t.isRequired)
    );

    const allRequiredSelected = computed(() => {
      if (requiredPackages.value.length === 0) return true;
      return requiredPackages.value.every(t =>
        dataForm.packages.additionalPackagingGroup.includes(t.title)
      );
    });

    function onRequiredPackageChange(id) {
      const optIds = new Set(optionalPackages.value.map(t => t.id));
      const optTitles = new Set(optionalPackages.value.map(t => t.title));
      dataForm.packages.additionalPackagingGroupIds =
        dataForm.packages.additionalPackagingGroupIds.filter(i => !optIds.has(i));
      dataForm.packages.additionalPackagingGroup =
        dataForm.packages.additionalPackagingGroup.filter(t => !optTitles.has(t));
      refreshPackages(id);
    }

    function onOptionalPackageChange(id) {
      refreshPackages(id);
    }

    function checkWarmWeightAndVolume() {
      let cargoVolumeDisplay = 0;
      let cargoWeightDisplay = 0;

      let cargoSpace = [];
        if (dataForm.cargoInformation.cargoSpaceType == "simple") {

            let calcVolume = 0;
            let calcWeight = 0;

              switch (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo)) {
                case 'Standart':
                  calcVolume = parseFloat(dataForm.cargoInformation.cargoVolume.toString().replace(/,/g, '.'));
                  calcWeight = parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'));
                  cargoVolumeDisplay = Number(calcVolume);
                  cargoWeightDisplay = Number(calcWeight);
                  break;
                case 'Cylinder':
                  calcVolume = Math.PI * (Math.pow(dataForm.cargoInformation.sizeOfCargoCylinder.diameter, 2) / 4) * dataForm.cargoInformation.sizeOfCargoCylinder.height / 1000000;
                  calcWeight = parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'));
                  cargoVolumeDisplay = Number(calcVolume);
                  cargoWeightDisplay = Number(calcWeight);
                  break;
                case 'Tires':
                  calcVolume = 0.085;
                  calcWeight = 8;
                  cargoVolumeDisplay = Number(calcVolume) * dataForm.cargoInformation.numberOfIdenticalLoads;
                  cargoWeightDisplay = Number(calcWeight) * dataForm.cargoInformation.numberOfIdenticalLoads;
                  break;
              } 
              
              cargoSpace.push({
                cargoType: getTypeOfCargo(dataForm.cargoInformation.typeOfCargo),
                attachmentCount: Number(dataForm.cargoInformation.numberOfIdenticalLoads),
                diametr: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter) : 0,
                length: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? 1 : parseFloat(dataForm.cargoInformation.cargoDimensions.length),
                width: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? 1 : parseFloat(dataForm.cargoInformation.cargoDimensions.width),
                height: (getTypeOfCargo(dataForm.cargoInformation.typeOfCargo) == "Cylinder") ? parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height) : parseFloat(dataForm.cargoInformation.cargoDimensions.height),
                weight: calcWeight,
                volume: calcVolume,
                cargoExtraPacking: 
                {
                  palletizing: (dataForm.packages.additionalPackagingGroup.includes("Паллетирование")) ? true : false,
                  stretchWrap: (dataForm.packages.additionalPackagingGroup.includes("Стретч")) ? true : false,
                  lathing: (dataForm.packages.additionalPackagingGroup.includes("Обрешётка")) ? true : false,
                  pallet: (dataForm.packages.additionalPackagingGroup.includes("Поддон")) ? true : false, 
                  boxes: (dataForm.packages.additionalPackagingGroup.includes("Коробка Мини")) ? "Size25x18x10" : (dataForm.packages.additionalPackagingGroup.includes("Коробка Стандарт")) ? "Size38x30x23" : (dataForm.packages.additionalPackagingGroup.includes("Пакет")) ? "3" : "none",
                  packet: false,
                  warmplace: (dataForm.packages.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                  mattressCover: (dataForm.packages.additionalPackagingGroup.includes("Наматрасник")) ? true : false,
                  uniPakMini: (dataForm.packages.additionalPackagingGroup.includes("УниПАК Мини")) ? true : false,
                  uniPakStandard: (dataForm.packages.additionalPackagingGroup.includes("УниПАК Стандарт")) ? true : false,
                }
              });
            
        } else {

          let calcVolume = 0;
          let calcWeight = 0;
      
          dataForm.cargoSpaceTabs.forEach((tab) => {

            switch (getTypeOfCargo(tab.typeOfCargo)) {
              case 'Standart':
                calcVolume = parseFloat(tab.cargoVolume.toString().replace(/,/g, '.'));
                calcWeight = parseFloat(tab.cargoWeight.toString().replace(/,/g, '.'));
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
              case 'Cylinder':
                calcVolume = Math.PI * (Math.pow(tab.diameter, 2) / 4) * tab.height / 1000000;
                calcWeight = parseFloat(tab.cargoWeight.toString().replace(/,/g, '.'));
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
              case 'Tires':
                calcVolume = 0.085;
                calcWeight = 8;
                cargoVolumeDisplay += Number(calcVolume);
                cargoWeightDisplay += Number(calcWeight);
                break;
            }

            let tabPackage = dataForm.packagesTabs[getPackageKey(tab.name)];
            cargoSpace.push({
              cargoType: getTypeOfCargo(tab.typeOfCargo),
              attachmentCount: 1,
              diametr: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? parseFloat(tab.diameter) : 0,
              length: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? 1 : parseFloat(tab.length),
              width: (getTypeOfCargo(tab.typeOfCargo) == "Cylinder") ? 1 : parseFloat(tab.width),
              height: parseFloat(tab.height),
              weight: calcWeight,
              volume: calcVolume,
              cargoExtraPacking: (tab.additionalPackaging == "false") ? 
              {
                warmplace: (tabPackage.additionalPackagingGroup.includes("Термобокс")) ? true : false,
              } : {
                palletizing: (tabPackage.additionalPackagingGroup.includes("Паллетирование")) ? true : false,
                stretchWrap: (tabPackage.additionalPackagingGroup.includes("Стретч")) ? true : false,
                lathing: (tabPackage.additionalPackagingGroup.includes("Обрешётка")) ? true : false,
                pallet: (tabPackage.additionalPackagingGroup.includes("Поддон")) ? true : false, 
                boxes: (tabPackage.additionalPackagingGroup.includes("Коробка Мини")) ? "Size25x18x10" : (tabPackage.additionalPackagingGroup.includes("Коробка Стандарт")) ? "Size38x30x23" : (tabPackage.additionalPackagingGroup.includes("Пакет")) ? "3" : "none",
                packet: false,
                warmplace: (tabPackage.additionalPackagingGroup.includes("Термобокс")) ? true : false,
                mattressCover: (tabPackage.additionalPackagingGroup.includes("Наматрасник")) ? true : false,
                uniPakMini: (tabPackage.additionalPackagingGroup.includes("УниПАК Мини")) ? true : false,
                uniPakStandard: (tabPackage.additionalPackagingGroup.includes("УниПАК Стандарт")) ? true : false,
              }
            });
          })
        }

        return cargoVolumeDisplay >= 0.5 || cargoWeightDisplay > 30;
    }

    function getTypeOfCargo(type) {
      switch (type) {
        case "Стандарт":
          return "Standart";
        case "Цилиндры":
          return "Cylinder";
        case "Шины":
          return "Tires";
      }
    }

    function checkSummer() {
      const month = new Date().getMonth();
      const isSummer = month >= 5 && month <= 7;
      return isSummer;
    }

    function checkWarm() {
      return checkWarmWeightAndVolume() || checkSummer() || (dataForm.services.typeOfPackagings.value ? (dataForm.services.typeOfPackagings.value.length == 0 || dataForm.services.typeOfPackagings.value?.every(item => { return item.title != "Термобокс"})) : true);
    }

    function checkCashOnDelivery() {
      return dataForm.services.cargoRedemption || dataForm.sender.cityFrom == "Алматы" || dataForm.consignee.cityTo == "Алматы"
    }

    return {
      dataForm,
      checkWarm,
      checkCashOnDelivery,
      natures,
      fnatures,
      natureDropdown,
      requiredNeeded,
      checkWarmWeightAndVolume,
      refreshPackages,
      checkIntersectionsTypes,
      requiredPackages,
      optionalPackages,
      allRequiredSelected,
      onRequiredPackageChange,
      onOptionalPackageChange,
      optionsWhoPaysTheRansom,
      communications,
      getArrayOfRules,
      warmPlaceChange: function() {
        // НЕОБХОДИМО НА ПРОСЛУШКУ УПАКОВОК ОБНОВЛЯТЬ dataForm.warmPlace

        // Производим проверку на сушествование элемента в массиве упаковок
        if(!dataForm.services.typeOfPackagings.value.every(item => { return item.title != "Термобокс"})) {
          
          refreshPackages(18)
          if(dataForm.packages.additionalPackagingGroup.includes('Термобокс')) {
            if(dataForm.services.typeOfPackagings.value.every(item => { return item.title != "Термобокс"})[0]?.isRequired != true) {
              dataForm.packages.additionalPackagingGroup = dataForm.packages.additionalPackagingGroup.filter(item => { return item != "Термобокс" })
              dataForm.packages.additionalPackagingGroup = dataForm.packages.additionalPackagingGroupIds.filter(item => { return item != 18 })
            }
          } else {
            dataForm.packages.additionalPackagingGroup.push('Термобокс');
            dataForm.packages.additionalPackagingGroupIds.push(18);
          }
          dataForm.warmPlace = !checkSummer() && dataForm.packages.additionalPackagingGroup.includes("Термобокс");
        } else {
          // Иначе экстренно отключаем WarmPlace
          dataForm.warmPlace = false;
        }
      },
      focusDropdown: function() {
        natureDropdown.value.handleOpen()
      },
      blurDropdown: function() {
        // setTimeout(() => natureDropdown.value.handleClose() , 250);
        natureDropdown.value.handleClose()
      },
      checkRedemption: function () {
        if (
          dataForm.services.whoPaysTheRansom === "1" &&
          Number(dataForm.services.cargoRedemptionSum) > 6000
        ) {
          dataForm.services.cargoRedemptionSum = 6000;
        }
      },
      filterOptions(query) { 
        if (query == "") fnatures.value = natures.value;
        fnatures.value = natures.value.filter(e => (e.title.toLowerCase().includes(query.toLowerCase()) || e.title.toLowerCase().includes('иное')))
      },

    };
  },
};
